module.exports = __webpack_public_path__ + "cancellara-dist/img/randstad.98d06620.png";